module.exports = __webpack_public_path__ + "EkagraMittal-52c2eb3f.webp";